import { useState, useEffect } from 'react';

const TABLET_MD_AND_UP = 768;

const setHeroImage = (image, mobImage, width) =>
  width < TABLET_MD_AND_UP && mobImage ? mobImage : image || '';

const useSetHeroImg = (image, mobImage, width) => {
  const [heroImg, setHeroImg] = useState();

  useEffect(() => {
    setHeroImg(setHeroImage(image, mobImage, width));
  }, [width, image, mobImage]);

  return heroImg;
};

export default useSetHeroImg;
